<template>
  <div  id="app">
    <!-- <nav class="navbar navbar-dark bg-dark">
      <a class="navbar-brand" href="#">CPRP Commenting Tool Demo</a>
    </nav> -->

    <div class="row">
      <div class="col-9" id="mapContainer">
        <button type="button" id="addCommentButton" v-on:click="openAddNewComment()" class="btn btn-dark">Add Comment <i class="fa fa-comment-dots"></i></button>
        <Map/>
      </div>
      <template v-if="!isAddNewComment">
        <div class="col-3 displayNone sideContainer border" id="flexContainer">
          <FlexContainer/>
        </div>
      </template>
      <div class="col-3 border sideContainer">
        <template v-if="isAddNewComment">
          <NewComment/>
        </template>
        <template v-else>
          <SideMenu/>
        </template>
      </div>
    </div>
    <notifications group="errors" classes="vue-notification text-dark" :reverse="true"/>
    <notifications group="successNotifications" classes="vue-notification text-dark" :reverse="true"/>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

import Map from './components/Map.vue'
import SideMenu from './components/SideMenu.vue'
import NewComment from './components/NewComment.vue'
import FlexContainer from './components/FlexContainer.vue'

import mapStateModule from "./state/modules/mapStateModule.js"

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    mapModule: mapStateModule,
  },
  strict: debug
})

export default {
  name: 'app',
  data () {
    return {
      isAddNewComment: false
    }
  },
  components: {
    Map,
    SideMenu,
    FlexContainer,
    NewComment
  },
  store:store,
  methods: {
    openAddNewComment: function() {
      const current = this
      current.isAddNewComment = !current.isAddNewComment
      var view =  document.getElementById("map").__vue__.view
      view.graphics.removeAll()
      var flexContainer = document.getElementById("flexContainer")
      if (flexContainer) {
        flexContainer.classList.add("displayNone")
        var map = document.getElementById("mapContainer")
        map.classList.remove("col-6")
        map.classList.add("col-9")
      }
    }
  }
}
</script>

<style>
.esri-icon-non-visible::before {
  content: "\e610" !important;
}
.esri-icon-visible::before {
  content: "\e611" !important;
}
.displayNone {
  display:none;
}
.sideContainer {
  /* border-style: ridge; */
  padding-left: 0!important;
  padding-right: 0!important;
}
div#mapContainer {
  /* padding-left: 0!important; */
  padding-right: 0!important;
}
/* html,body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
} */
#app {
  overflow: hidden;
  /* display: flex;
  flex-direction: column; */
  /* padding: 0;
  margin: 0;
  width: 100%;
  height: 100%; */
}
</style>
